import { ofType } from 'redux-observable';
import { filter, map, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { dashboardTileDuplicated } from 'state/quotes/dashboard/dashboard.actions';
import type { EpicWithThunk } from 'state/state.common';

import { quoteRequestFailure$ } from './createTile.epic';
export function duplicateTileEpic(): EpicWithThunk {
  return (
    action$,
    $state,
    {
      selectors: {
        dashboard: { getTileMetadata },
      },
    },
  ) => {
    return action$.pipe(
      ofType('DASHBOARD_TILE_DUPLICATING'),
      mergeMap(tile =>
        action$.pipe(
          ofType('QUOTE_ACKED'),
          takeUntil(quoteRequestFailure$(action$, tile.workspace, tile.reconciliationId)),
          filter(ack => ack.frontReconciliationId === tile.reconciliationId),
          withLatestFrom($state),
          map(([ack, state]) => {
            const originalQuoteMetadata = getTileMetadata(state, tile.originalQuoteId);
            return dashboardTileDuplicated(ack.quoteId, tile.originalQuoteId, originalQuoteMetadata);
          }),
        ),
      ),
    );
  };
}
